export enum WhatsAppCallingStatus {
  NOT_SET = 'NOT_SET',
  ENABLED = 'ENABLED',
  DISABLED = 'DISABLED',
}
